import React from 'react';

import {
  Stack,
  Typography,
  Tooltip,
  TypographyList,
  TypographyListItem,
  FactCheckIcon,
  ArticleIcon,
} from '@gogame/components';
import { ScreenLink } from '@gogame/screens';

import { promoCodeDetailsLink } from 'scenes/PromoCodes/navigation';

import {
  REWARDS,
  CONDITIONAL_PROMOCODE,
  NON_CONDITIONAL_PROMOCODE,
} from 'scenes/PromoCodes/components/PromoCodesDataTable/constants';

const RewardsText = ({ data = [] }) => {
  return (
    <Typography noWrap={true} variant={'caption'}>
      {data.map(({ name }) => name.toUpperCase()).join(', ')}
    </Typography>
  );
};

const List = ({ data = [], name }) => {
  return (
    <TypographyList unitsLabel={name} limit={0} menuVariant={'caption'}>
      {data.map(({ name, id }) => (
        <TypographyListItem key={id}>{name}</TypographyListItem>
      ))}
    </TypographyList>
  );
};

const NameColumn = ({ value, row }) => {
  const { rewards, conditionalRewardsCount } = row;
  const REWARDS_LENGTH = rewards.length;

  return (
    <Stack
      direction={'row'}
      spacing={2}
      alignItems={'center'}
      zeroMinWidth={true}
    >
      <Tooltip
        title={
          conditionalRewardsCount
            ? CONDITIONAL_PROMOCODE
            : NON_CONDITIONAL_PROMOCODE
        }
        wrapper={true}
      >
        {conditionalRewardsCount ? (
          <FactCheckIcon color={'action'} />
        ) : (
          <ArticleIcon color={'action'} />
        )}
      </Tooltip>

      <Stack spacing={1} zeroMinWidth={true}>
        <Stack spacing={1} direction={'row'} alignItems={'center'}>
          <ScreenLink
            link={promoCodeDetailsLink}
            pathParams={{
              id: row.id,
            }}
            style={{
              minWidth: 0,
            }}
          >
            <Typography noWrap={true} variant={'body2'}>
              {value}
            </Typography>
          </ScreenLink>
        </Stack>

        <Stack spacing={1} zeroMinWidth={true}>
          <Typography color={'textSecondary'} variant={'caption'} noWrap={true}>
            {row.code}
          </Typography>
        </Stack>

        <Stack direction={'row'} spacing={1}>
          {conditionalRewardsCount ? (
            <>
              <List data={rewards} name={REWARDS} />
              <Typography variant={'caption'}>{' | '}</Typography>
            </>
          ) : REWARDS_LENGTH > 2 ? (
            <List data={rewards} name={REWARDS} />
          ) : (
            <RewardsText data={rewards} />
          )}

          {conditionalRewardsCount ? (
            <Typography variant={'caption'}>
              {conditionalRewardsCount} CONDITIONAL REWARDS
            </Typography>
          ) : null}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default NameColumn;
